import { Loader } from '@treedis/tour-loader';
import { useState } from 'react';
import { Overlay, Container, Content, IFrame, Button, LoaderContainer } from './VSHTMLPopup.styles';
import DeviceManager from '@/components/util/deviceManager';

interface IVSHTMLPopup {
  setShow: (value: boolean) => void;
  src: string | null;
}

export const VSHTMLPopup: React.FC<IVSHTMLPopup> = ({ setShow, src }) => {
  const [showLoader, setShowLoader] = useState(true);
  const isHorizontal = DeviceManager.isHorizontalMobileView();

  return (
    <Overlay>
      <Container
        onClick={() => {
          setShow(false);
        }}
        isHorizontal={isHorizontal}
      >
        <Content isHorizontal={isHorizontal}>
          <LoaderContainer show={showLoader}>
            <Loader color="black" />
          </LoaderContainer>
          <IFrame
            src={src}
            onLoad={() => {
              setShowLoader(false);
            }}
          />
        </Content>
        <Button>
          <img src="/images/cross.svg" alt="close" />
        </Button>
      </Container>
    </Overlay>
  );
};
